import { render, staticRenderFns } from "./NewPaymentsPayoneerTableAdmin.vue?vue&type=template&id=55b1d2a0&scoped=true"
import script from "./NewPaymentsPayoneerTableAdmin.vue?vue&type=script&lang=js"
export * from "./NewPaymentsPayoneerTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b1d2a0",
  null
  
)

export default component.exports